import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
  button: {
    backgroundColor: '#283f60',
    color: 'white',
    border: '1px solid #1a314c',
    '&:hover': {
      backgroundColor: '#1a314c',
      border: '1px solid #f6edd4',
    }
  }
}));

const Modal = ({ code, handleClose, open }) => {
  const classes = useStyles();

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle id="alert-dialog-title">Invalid Access Code: {code}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The access code you entered is invalid. Please check the code provided via email or during your train-the-trainer experience and try again. If you need help contact us at 877.335.7589.
          </DialogContentText>
          <DialogActions>
            <Button className={classes.button} onClick={handleClose}>OK</Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Modal;
